import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-tracit-aihome',
  templateUrl: './aihome.component.html',
  styleUrls: ['./aihome.component.css']
})
export class TracItAIHomeComponent implements OnInit {

  years: any = Date.now();
  lastLogin: string = '';
  name: string = '';
  ClientSelectedTool: string;

  constructor(private readonly titleService: Title) {
    this.lastLogin = sessionStorage.getItem('LastLogin');    
    this.name = sessionStorage.getItem('FirstLastName');
    this.ClientSelectedTool = sessionStorage.getItem('ClientLoginTool');
    this.titleService.setTitle('Home | JSi360');
  }

  ngOnInit() {
  }

}
